import script from "./ReassignmentReferralTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReassignmentReferralTable.vue?vue&type=script&setup=true&lang=ts"

import "./ReassignmentReferralTable.vue?vue&type=style&index=0&id=0b576fbf&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b576fbf"]])

export default __exports__